import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";
import { paymentContext } from "./context";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { paymentInfo, setPaymentInfo, isPaymentOnProgress, setIsPaymentOnProgress } = useContext(paymentContext);
  const [open, setOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    if (isPaymentOnProgress === false) {
      navigate('/');
      return;
    }

    const sendData = async () => {
      try {
        const responseAPI = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/orderUpdateFunctionality', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            // ...paymentInfo
            // ["order_status"] = "payment successfull"
            order_status: "payment successfull",
            order_id: paymentInfo.order_id
          })
        })

        const data2 = await responseAPI.json();
        console.log("place order response", data2);

        if (data2?.statusCode !== 200) {
          await new Promise((resolve) => {
            setIsPaymentOnProgress(false);
            setPaymentInfo(null);
            setOpen(true);
            setTimeout(resolve, 1000);
            setShowButton(true);
            // setTimeout(() => {
            //   setOpen(false);
            //   navigate('/')
            // }, 5000)
          })
          return;
        }
        localStorage.removeItem('cart');
        localStorage.removeItem('coupon');
        await new Promise((resolve) => {
          setIsPaymentOnProgress(false);
          setPaymentInfo(null);
          setTimeout(resolve, 1000);
          setShowButton(true);
        })


        // setTimeout(() => {
        //   navigate('/')
        // }, 5000)



        // const responseNotification = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/notificationOrderCreation', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     phone_number: paymentInfo["billing_address"].phone
        //   })
        // })

        // const dataNotification = await responseNotification.json();
        // console.log("dataNotification", dataNotification);

        //console.log("place order response", data2);
        // if (data2.statusCode === 200 && dataNotification.statusCode === 200) {
        //   localStorage.removeItem('cart');
        //   localStorage.removeItem('coupon');
        //   await new Promise((resolve) => {
        //     setIsPaymentOnProgress(false);
        //     setPaymentInfo(null);
        //     setTimeout(resolve, 1000);
        //   })


        //   setTimeout(() => {
        //     navigate('/')
        //   }, 10000)
        // } else {
        //   setOpen(true);
        //   await new Promise((resolve) => {
        //     setIsPaymentOnProgress(false);
        //     setPaymentInfo(null);
        //     setTimeout(resolve, 1000);
        //   })
        //   setTimeout(() => {
        //     navigate('/checkout')
        //   }, 10000)
        // }
      } catch (error) {
        console.error("sending the order data to backend failed", error);
      }
    }
    sendData();
  }, [])
  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '70vw',
        backgroundColor: '#198754',
        color: 'white',
        margin: 'auto',
        marginTop: '5%',
        padding: '1%',
        justifyContent: 'center',
        borderRadius: '0.5rem',
        textAlign: 'center',
        flexDirection: 'column',
        rowGap: '4vh'
      }}>
        <h1>Your Payment Was successfully, Thank You for shopping at Khoslaonline.</h1>
        {showButton && <button
          style={{
            backgroundColor: 'black',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem'
          }}
          onClick={() => {
            navigate('/')
            setIsPaymentOnProgress(false);
            setPaymentInfo(null);
            setShowButton(false);
          }}>Go to Home</button>}
      </div>

      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
      <About_p />
      <Footer />
      <StickyComponent />

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          style={{ color: 'red' }}>Issue Occurred !!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Failed to place order , Please contact Customer Care
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PaymentSuccess;